<template>
  <div class="wrapper" >
    <div class="input__wrapper">
      <input type="text" v-model="minValue" @input="onInput();" :placeholder="minValue">
      <input type="text" v-model="maxValue" @input="onInput();" :placeholder="maxValue">
    </div>
    <div class="track-container">
      <div class="track" ref="_vpcTrack" />
      <div class="track-highlight" ref="trackHighlight" />
      <button class="track-btn track1" ref="track1" 
        @mouseup="(event) => mouseup(event, 'track1')"
        @mousemove="(event) => mousemove(event, 'track1')"
      />
      <button class="track-btn track2" ref="track2" 
        @mouseup="(event) => mouseup(event, 'track2')"
        @mousemove="(event) => mousemove(event, 'track2')"
      />
    </div>
  </div>  
</template>

<script>
export default {
  name: "PriceRangeSlider",

  props: {
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      minValue: this.min,
      maxValue: this.max,
      step: 10,
      totalSteps: 0,
      percentPerStep: 1,
      trackWidth: null,
      isDragging: false,
      pos: {
        curTrack: null,
      },
    };
  },

  methods: {
    onInput() {
      this.$emit('update', { from: this.minValue, to: this.maxValue });
    },
    moveTrack(track, ev) {
      let percentInPx = this.getPercentInPx();

      let trackX = Math.round(
        this.$refs._vpcTrack.getBoundingClientRect().left
      );
      let clientX = ev.clientX;
      let moveDiff = clientX - trackX;

      let moveInPct = moveDiff / percentInPx;

      if (moveInPct < 1 || moveInPct > 100) return;
      let value =
        Math.round(moveInPct / this.percentPerStep) * this.step + this.min;
      if (track === "track1") {
        if (value >= this.maxValue - this.step) return;
        this.minValue = value;
      }

      if (track === "track2") {
        if (value <= this.minValue + this.step) return;
        this.maxValue = value;
      }

      this.$refs[track].style.left = moveInPct + "%";
      this.setTrackHightlight();
    },
    mousedown(ev, track) {
      if (this.isDragging) return;
      this.isDragging = true;
      this.pos.curTrack = track;
    },

    touchstart(ev, track) {
      this.mousedown(ev, track);
    },

    mouseup(ev, track) {
      if (this.isDragging && this.pos.curTrack) {
       this.isDragging = false;
        this.$emit('update', { from: this.minValue, to: this.maxValue });
    }

    },

    touchend(ev, track) {
      this.mouseup(ev, track);
    },

    mousemove(ev, track) {
      if (!this.isDragging) return;
      this.moveTrack(track, ev);
    },

    touchmove(ev, track) {
      this.mousemove(ev.changedTouches[0], track);
    },

    valueToPercent(value) {
      return ((value - this.min) / this.step) * this.percentPerStep;
    },

    setTrackHightlight() {
      this.$refs.trackHighlight.style.left =
        this.valueToPercent(this.minValue) + "%";
      this.$refs.trackHighlight.style.width =
        this.valueToPercent(this.maxValue) -
        this.valueToPercent(this.minValue) +
        "%";
    },

    getPercentInPx() {
      let trackWidth = this.$refs._vpcTrack.offsetWidth;
      let oneStepInPx = trackWidth / this.totalSteps;
      // 1 percent in px
      let percentInPx = oneStepInPx / this.percentPerStep;

      return percentInPx;
    },

    setClickMove(ev) {
      let track1Left = this.$refs.track1.getBoundingClientRect().left;
      let track2Left = this.$refs.track2.getBoundingClientRect().left;
      if (ev.clientX < track1Left) {
        this.moveTrack("track1", ev);
      } else if (ev.clientX - track1Left < track2Left - ev.clientX) {
        this.moveTrack("track1", ev);
      } else {
        this.moveTrack("track2", ev);
      }
    },
  },

  mounted() {
    // calc per step value
    this.totalSteps = (this.max - this.min) / this.step;

    // percent the track button to be moved on each step
    this.percentPerStep = 100 / this.totalSteps;

    // set track1 initilal
    document.querySelector(".track1").style.left =
      this.valueToPercent(this.minValue) + "%";
    // track2 initial position
    document.querySelector(".track2").style.left =
      this.valueToPercent(this.maxValue) + "%";
    // set initila track highlight
    this.setTrackHightlight();

    var self = this;

    // ["mouseup", "mousemove"].forEach((type) => {
    //   document.body.addEventListener(type, (ev) => {
    //     // ev.preventDefault();
    //     if (self.isDragging && self.pos.curTrack) {
    //       self[type](ev, self.pos.curTrack);
    //     }
    //   });
    // });

    [
      "mousedown",
      "mouseup",
      "mousemove",
      "touchstart",
      "touchmove",
      "touchend",
    ].forEach((type) => {
      document.querySelector(".track1").addEventListener(type, (ev) => {
        ev.stopPropagation();
        self[type](ev, "track1");
      });

      document.querySelector(".track2").addEventListener(type, (ev) => {
        ev.stopPropagation();
        self[type](ev, "track2");
      });
    });

    // on track clik
    // determine direction based on click proximity
    // determine percent to move based on track.clientX - click.clientX
    document.querySelector(".track").addEventListener("click", function (ev) {
      ev.stopPropagation();
      self.setClickMove(ev);
    });

    document
      .querySelector(".track-highlight")
      .addEventListener("click", function (ev) {
        ev.stopPropagation();
        self.setClickMove(ev);
      });
  },

};
</script>

<style scoped>
.wrapper{
  margin-bottom: 45px;
}
.input__wrapper{
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
input {
  border: none;              /* Убираем все бордеры */
  border-bottom: 1px solid rgb(222, 230, 234);; /* Добавляем только нижний бордер */
  outline: none;             /* Убираем контур при фокусе */
  padding-bottom: 6px;            /* Отступы только по вертикали */
  font-size: 16px;           /* Размер шрифта */
  width: 100%;               /* Ширина инпута на всю доступную ширину */
  max-width: 86px;
  /* Paragraph/P3: 16px Regular */
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}

input:focus {
  border-bottom-color: rgb(222, 230, 234);; /* Цвет нижнего бордера при фокусе */
}
.range-value {
  position: absolute;
  top: -2rem;
}
.range-value.min {
  left: 0;
}

.range-value.max {
  right: 0;
}
.track-container {
  width: 100%;
  position: relative;
  cursor: pointer;
  margin-top: 20px;
}

.track,
.track-highlight {
  display: block;
  position: absolute;
  width: 100%;
  height: 2px;
}

.track {
  background-color: rgb(222, 230, 234);;
}

.track-highlight {
  background-color: rgb(255, 183, 16);;
  z-index: 2;
}

.track-btn {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
  display: block;
  position: absolute;
  z-index: 2;
  width: 24px;
  height: 24px;
  top: calc(-50% - 12px);
  margin-left: -1rem;
  border: none;
  border-radius: 100%;
  border: 2px solid rgb(255, 255, 255);
  background-color: rgb(255, 183, 16);;
  -ms-touch-action: pan-x;
  touch-action: pan-x;
  transition: box-shadow 0.3s ease-out, background-color 0.3s ease,
    -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out,
    background-color 0.3s ease;
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out,
    background-color 0.3s ease, -webkit-transform 0.3s ease-out;
}
</style>
